import { useContext } from 'react';
import { OrganizerContext } from './OrganizerContext';
import {
    OrganizerBasicInfo,
    OrganizerContextValue,
    OrganizerQualityInfo,
    OrganizerSocialInfo,
} from './types';

export const useOrganizerContext = (): OrganizerContextValue => {
    const context = useContext(OrganizerContext);

    if (!context) {
        throw new Error(
            'useOrganizerContext must be used within an OrganizerProvider',
        );
    }

    return context;
};

export const useOrganizerBasicInfo = (): OrganizerBasicInfo => {
    const { basicInfo } = useOrganizerContext();
    return basicInfo;
};

export const useOrganizerSocialInfo = (): OrganizerSocialInfo => {
    const { socialInfo } = useOrganizerContext();
    return socialInfo;
};

export const useOrganizerQualityInfo = (): OrganizerQualityInfo => {
    const { qualityInfo } = useOrganizerContext();
    return (
        qualityInfo || {
            isLoadingSignal: false,
        }
    );
};
